<div class="filter-range">
  <ng-container *ngIf="isLoading$ | async; then loader; else rangeInputs"></ng-container>
</div>
<ng-template #loader>
  <mode-loader class="loader" [class.visible]="showLoader$ | async" type="secondaryGreen"></mode-loader>
</ng-template>
<ng-template #rangeInputs>
  <div class="field-group">
    <input
      data-test="filter-range-numeric-min"
      type="number"
      class="form-control form-control-sm range-filter-input"
      step="any"
      placeholder="{{ dataMin }}"
      [ngModel]="min"
      (ngModelChange)="onMinChange($event)"
      (focus)="onFocusInput($event)"
      (blur)="onBlurInput()"
    />
    <span class="range-separator">&ndash;</span>
    <input
      data-test="filter-range-numeric-max"
      type="number"
      class="form-control form-control-sm range-filter-input"
      step="any"
      placeholder="{{ dataMax }}"
      [ngModel]="max"
      (ngModelChange)="onMaxChange($event)"
      (focus)="onFocusInput($event)"
      (blur)="onBlurInput()"
    />
  </div>
</ng-template>
